import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["title"];
const _hoisted_2 = ["title"];
const _hoisted_3 = ["title"];
const _hoisted_4 = ["title"];
const _hoisted_5 = { class: "ta-c" };
import vuexStore from '@/vuex-store';
import { toRefs } from 'vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'AvailableWorkerRow',
    props: {
        item: {
            type: Object,
            default: () => { },
        },
    },
    setup(__props) {
        const props = __props;
        const { item } = toRefs(props);
        const handleClickRegisterBtn = (worker) => {
            vuexStore.dispatch('workerManagement/deliveryFeeGroupWorkerSetting/setFeeGroupRegisterList', worker);
        };
        return (_ctx, _cache) => {
            const _component_v_icon = _resolveComponent("v-icon");
            const _component_v_btn = _resolveComponent("v-btn");
            return (_openBlock(), _createElementBlock("tr", null, [
                _createElementVNode("td", {
                    title: _unref(item).name,
                    class: "ta-s td__worker-name"
                }, _toDisplayString(_unref(item).name), 9 /* TEXT, PROPS */, _hoisted_1),
                _createElementVNode("td", {
                    title: _unref(item).code,
                    class: "ta-s td__worker-code"
                }, _toDisplayString(_unref(item).code), 9 /* TEXT, PROPS */, _hoisted_2),
                _createElementVNode("td", {
                    title: _unref(item).hubEmployeeNumber,
                    class: "ta-s td__worker-code"
                }, _toDisplayString(_unref(item).hubEmployeeNumber), 9 /* TEXT, PROPS */, _hoisted_3),
                _createElementVNode("td", {
                    title: _unref(item).groupName,
                    class: "ta-s td__group-name"
                }, _toDisplayString(_unref(item).groupName), 9 /* TEXT, PROPS */, _hoisted_4),
                _createElementVNode("td", _hoisted_5, [
                    _createVNode(_component_v_btn, {
                        icon: "mdi-plus",
                        variant: "text",
                        color: "blue",
                        small: "",
                        density: "comfortable",
                        onClick: _cache[0] || (_cache[0] = ($event) => (handleClickRegisterBtn(_unref(item))))
                    }, {
                        default: _withCtx(() => [
                            _createVNode(_component_v_icon, null, {
                                default: _withCtx(() => _cache[1] || (_cache[1] = [
                                    _createTextVNode(" mdi-plus ")
                                ])),
                                _: 1 /* STABLE */,
                                __: [1]
                            })
                        ]),
                        _: 1 /* STABLE */
                    })
                ])
            ]));
        };
    }
});
